///Parse YYYYMMDDD into a date
export const stringToDate = (date: string) => {
    
    const year = date.substring(0, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6);
    return new Date(`${year}-${month}-${day}`);
}